import { hmapPathParamConfig, hmapPathParamRegex } from "@ngmodules/hmap/hmap.routes";
export const HmapSettingsRoutes = [
    {
        "url": `/settings/${hmapPathParamRegex}?activeTab&subTab`,
        "name": "appLayout.harriSH.access-portal.settings.main",
        "type": "frontend",
        "showGlobalSearch": true,
        "loginRequired": true,
        "params": {
            ...hmapPathParamConfig
        },
        "component": "hmapSettingsPage",
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", "documents-default-fields", 'restricted_positions', "minimum-minor-age"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/settings/hmap-settings.downgrade.module");
                }
            }, {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/eeo-questions-settings/eeo-questions-settings.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/documents-default-fields/documents-default-fields.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/minimum-minor-age/minimum-minor-age.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/global-tags-management/global-tags-management.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/break-waivers/break-waivers.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/organization-settings/organization-settings.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/career-story-page-manger/career-story-page-manger.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-automation/automated-onboarding.downgrade.module");
                }
            },
        ]
    },
    {
        "url": "/settings",
        "enableUTM": true,
        "name": "appLayout.harriSH.settings",
        "type": "frontend",
        "templateUrl": "../modules/settings/views/settings.html",
        "controller": 'SettingsController',
        "loginRequired": true,
        "showGlobalSearch": true,
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["custom-docs", "documents-default-fields", 'restricted_positions', "minimum-minor-age"]
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/settings/hmap-settings.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/custom-docs/custom-docs.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/eeo-questions-settings/eeo-questions-settings.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/documents-default-fields/documents-default-fields.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/minimum-minor-age/minimum-minor-age.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/break-waivers/break-waivers.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("@ngmodules/career-story-page-manger/career-story-page-manger.downgrade.module");
                }
            },
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/onboarding-automation/automated-onboarding.downgrade.module");
                }
            },
        ]
    }
];
//# sourceMappingURL=hmap-settings.routes.js.map